import React, { Component } from 'react';

import { H1, H2, Container } from 'components';
import { CustomValue, CustomLabel } from 'modules/form';

import AppStore from 'AppStore';
import { withRouter } from 'react-router-dom';

import * as Strings from 'app/utils/strings';
import CustomText from 'app/common/components/CustomText';
import CustomButton from 'app/common/components/CustomButton';
import CustomTextArea from 'app/common/components/CustomTextArea';
import CustomSelect from 'app/common/components/CustomSelect';
import TermOption from 'app/pages/quotes/components/TermOption';
import CustomPaymentOption from 'app/common/components/CustomPaymentOption';

import { getQuote } from '../../QuoteActions';

import './QuotePage.css';

class QuotePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            quoteId: this.props.match.params.quoteId,
            shareId: this.props.match.params.shareId
        };
    }
    //quote/79c1c14d-b45e-4912-8fb1-e49c9631607e/share/9ed3e5b4-5ee3-476a-9a9e-5e2b52637661/
    // {
    //     "data":{
    //        "id":"d129692e-7d84-45bd-aba4-be23ab2f4513",
    //        "createdBy":"de8ee33c-a0fc-4e09-8462-7414a1a5e36e",
    //        "cost":10000,
    //        "leaseType":"",
    //        "payments":[
    //           {
    //              "id":"b24c285b-1ecb-4bd4-a0a1-8b67dc50f2b8",
    //              "amount":null,
    //              "costOfFinanceRate":null,
    //              "term":24,
    //              "quoteId":"d129692e-7d84-45bd-aba4-be23ab2f4513",
    //              "updatedAt":"2018-02-09T10:24:19.743Z",
    //              "createdAt":"2018-02-09T10:24:19.743Z"
    //           },
    //           {
    //              "id":"c16eb3e9-7cfa-4be6-9593-3a0b9f511959",
    //              "amount":null,
    //              "costOfFinanceRate":null,
    //              "term":36,
    //              "quoteId":"d129692e-7d84-45bd-aba4-be23ab2f4513",
    //              "updatedAt":"2018-02-09T10:24:19.744Z",
    //              "createdAt":"2018-02-09T10:24:19.744Z"
    //           },
    //           {
    //              "id":"e38935d8-9bcd-439b-9928-f246eb316da3",
    //              "amount":null,
    //              "costOfFinanceRate":null,
    //              "term":48,
    //              "quoteId":"d129692e-7d84-45bd-aba4-be23ab2f4513",
    //              "updatedAt":"2018-02-09T10:24:19.748Z",
    //              "createdAt":"2018-02-09T10:24:19.748Z"
    //           },
    //           {
    //              "id":"d9b8261e-83c2-4a29-aef6-e27195bf0754",
    //              "amount":null,
    //              "costOfFinanceRate":null,
    //              "term":60,
    //              "quoteId":"d129692e-7d84-45bd-aba4-be23ab2f4513",
    //              "updatedAt":"2018-02-09T10:24:19.749Z",
    //              "createdAt":"2018-02-09T10:24:19.749Z"
    //           }
    //        ],
    //        "isVendor":true,
    //        "updatedAt":"2018-02-09T10:24:19.729Z",
    //        "createdAt":"2018-02-09T10:24:19.729Z"
    //     }
    //  }
    componentWillMount = () => {
        AppStore.on('quote_loaded', this.onQuoteLoaded);
        const cb = () => {
            getQuote(this.state.quoteId);
        };
        setTimeout(cb, 500);
    };

    componentWillUnmount = () => {
        AppStore.removeListener('quote_loaded', this.onQuoteLoaded);
    };
    onQuoteLoaded = () => {
        this.setState({ quote: AppStore.getQuote() });
    };
    onSendToCustomer = () => {
        //check if profile/navigate to profile/sendQuote
        //set credit lesseeId, cost, businessName
        //else navigate to quotes/send/:id
        this.props.history.push('/quote/send/' + this.state.quote.id);
    };
    onApplyNow = () => {
        //set credit app to step 1
        //check if profile/navigate to profile/credit
        //set credit lesseeId, cost, businessName
        //else
        //navigate to credit
        this.props.history.push('/credit/' + this.state.quote.id);
    };

    getLabel = (term, leaseType) => {
        let label = term + ' Months';
        let months = term;
        if (leaseType != 'Stretch') {
            return label;
        }

        switch (term) {
            case 24:
                months = 27;
                break;
            case 36:
                months = 40;
                break;
            case 48:
                months = 52;
                break;
            case 60:
                months = 66;
                break;
        }
        return months + ' Months';
    };
    getfooter = (term, leaseType) => {
        if (leaseType === 'Stretch') {
            return `10% of Invoice at ${term}M`;
        } else {
            return `$10 at ${term}M`;
        }
    };
    getPaymentsHtml = quote => {
        return quote.payments.map(payment => (
            <CustomPaymentOption
                label={this.getLabel(payment.term, quote.leaseType)}
                textValue={payment.amount}
                customRef={payment.id}
                format="currency"
                footer={this.getfooter(payment.term, quote.leaseType)}
            />
        ));
    };
    render() {
        if (!this.state.quote) {
            return (
                <div className="hack">
                    <div id="app-container">
                        <center>loading...</center>
                    </div>
                </div>
            );
        }
        const user = AppStore.getUser();

        const payments = this.getPaymentsHtml(this.state.quote);
        const quote = this.state.quote;

        return (
            <div className="hack">
                <div id="app-container">
                    <div id="quotes-container" className="form-container">
                        {/* <div className="quote-preview-header">
                            <span className="quote-preview-name">
                                {user.firstName} {user.lastName}
                            </span>
                            <span className="quote-preview-date">
                                ({user.email})
                            </span>
                        </div> */}
                        <div class="row">
                            <CustomText
                                label="Equipment Costs"
                                textValue={quote.cost}
                                format="currency"
                            />
                            <CustomText
                                label="Purchase Option"
                                textValue="See Purchase Option below payment"
                            />
                        </div>
                        <div className="select-quote-options">
                            <h2>Monthly Payments</h2>
                            <br />
                            <div className="row select-term">{payments}</div>
                        </div>
                    </div>
                    {/* <CustomButton
                    action={this.onBack.bind(this)}
                    className="left back-button"
                >
                    {Strings.QUOTES_BTN_BACK}
                </CustomButton> */}
                    {!this.state.shareId && (
                        <CustomButton
                            ref={CustomButton =>
                                (this.btnSendQuote = CustomButton)
                            }
                            action={this.onSendToCustomer}
                            className="right next-button"
                            type="submit"
                            style={{ margin: '0 0 15px 15px ' }}
                        >
                            {Strings.QUOTES_BTN_SAVE_AND_SEND}
                        </CustomButton>
                    )}

                    <CustomButton
                        ref={CustomButton => (this.btnSendQuote = CustomButton)}
                        action={this.onApplyNow}
                        className="right next-button"
                        type="submit"
                        style={{
                            backgroundColor: '#EF3340 ',
                            boxShadow: '0 1.5px 0 0 #d16e6e'
                        }}
                    >
                        Apply Now!
                    </CustomButton>
                </div>
            </div>
        );
    }
    // render() {
    //     return (
    //         <div className="hack">
    //             <div className="quote-page page">
    //                 <Container grid={12}>
    //                     <H1>Lease Quote</H1>
    //                     <div className="custom-text">
    //                         <div className="payment">
    //                             <CustomLabel>Test</CustomLabel>
    //                             <CustomValue>Value</CustomValue>
    //                         </div>
    //                     </div>
    //                     <div className="custom-text">
    //                         <CustomLabel>Test</CustomLabel>
    //                         <CustomValue>Value</CustomValue>
    //                     </div>
    //                     <div className="custom-text">
    //                         <CustomLabel>Test</CustomLabel>
    //                         <CustomValue>Value</CustomValue>
    //                     </div>
    //                     <div className="custom-text">
    //                         <CustomLabel>Test</CustomLabel>
    //                         <CustomValue>Value</CustomValue>
    //                     </div>
    //                 </Container>
    //             </div>
    //         </div>
    //     );
    // }
    // render() {
    //     console.log('THIE PROPS', AppStore.getAppState());
    //     return <div />;
    // }
}

export default withRouter(QuotePage);
//     render() {
//         return (
//             <div className="hack">
//                 <div className="quote-page page">
//                     <Container grid={12}>
//                         <H1>Lease Quote</H1>
//                         <div className="custom-text">
//                             <div className="payment">
//                                 <CustomLabel>Test</CustomLabel>
//                                 <CustomValue>Value</CustomValue>
//                             </div>
//                         </div>
//                         <div className="custom-text">
//                             <CustomLabel>Test</CustomLabel>
//                             <CustomValue>Value</CustomValue>
//                         </div>
//                         <div className="custom-text">
//                             <CustomLabel>Test</CustomLabel>
//                             <CustomValue>Value</CustomValue>
//                         </div>
//                         <div className="custom-text">
//                             <CustomLabel>Test</CustomLabel>
//                             <CustomValue>Value</CustomValue>
//                         </div>
//                     </Container>
//                 </div>
//             </div>
//         );
//     }



// WEBPACK FOOTER //
// ./src/modules/quote/pages/quote/QuotePage.jsx